import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './templates/FunctionHeadDispoMain.html?raw';
import domConstructTyped from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
// NOTE (JS2TS): dropped dead dojo deps (dom-attr, dom-style, _base/connect). DOM-heavy → dom-construct aliased.
// $ (jQuery) and dateFormat are runtime globals used verbatim by the original; declared ambiently here.
declare const $: any;
declare const dateFormat: any;

const domConstruct: any = domConstructTyped;

class FunctionHeadDispoMain extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    currentLoadedProjectItems: any = null;

    startup(): void {

        this._loadedModules = [];

        this.loadProjects();
        this.loadFunctionalHeadGroups();
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    currentLoadedMusicanItems: any = null;
    _dispoLoadRegistry = 0;
    _loadedModules: any = [];

    _handleResponseGeneric(response: any, disabledSpinner?: any): any { // RIP _handleResponseResponse
        if (typeof (disabledSpinner) == "undefined") {
            disabledSpinner = true;
        }

        if (disabledSpinner === true)
            //spinners.global().stop();
            this.StandbyStop();

        if (response.Exception === true) {
            $("#display_error").html(response.Message);
            $('html, body').animate({ scrollTop: ($("#display_error").offset().top) }, 'slow');
            return false;
        }

        return true;

    }

    checkLoadedModules(): void {
        if (this._loadedModules.length == 2) {
            $("#btn_load_musicans").attr("disabled", false);
        }
    }



    _GetAttributeValueFromAttributeArray(AttributeArray: any, AttributeName: any): any {
        for (var x = 0; x < AttributeArray.length; x++) {
            if (AttributeArray[x].Name == AttributeName) {
                return AttributeArray[x].Value;
            }
        }
    }

    _setRadioInputValue(item: any): void {
        $("#" + item.input_name + item.DutyTypeCode_2).prop("checked", true);
    }

    _selectionItemClick(e: any): void {
        //console.log(e.target.value);
        //console.log("_selectionItemClick", this.currentLoadedMusicanItems);

        for (var i = 0; i < this.currentLoadedMusicanItems.length; i++) {
            var item = this.currentLoadedMusicanItems[i];

            if (item.input_name == e.target.name) {

                item.DutyTypeCode_2 = e.target.value;

                //spinners.global().spin(document.getElementById('spinner_box'));
                this.StandbyStart();

                var url = window.appRoot + "SOV/OrchestraSetFunctionHeadDispoValue";

                this.RequestManager.post(
                    url,
                    {
                        item: JSON.stringify(item)
                    },
                    lang.hitch(this, "_onSelectionItemClickResponse", e),
                    lang.hitch(this, "_onSelectionItemClickError", e),
                    false // sync
                );
            }
        }
    }

    _onSelectionItemClickResponse(e: any, response: any): void {

        if (response.Exception == undefined) {
            var elem = $('#' + e.target.name + "_system_message");
            elem.html("gespeichert!");
            elem.css("color", "green");

            for (var itemIndex = 0; itemIndex < this.currentLoadedMusicanItems.length; itemIndex++) {
                if (this.currentLoadedMusicanItems[itemIndex].ref_ev_project == response.ref_ev_project &&
                    this.currentLoadedMusicanItems[itemIndex].ref_engagement == response.ref_engagement) {
                    response.input_name = this.currentLoadedMusicanItems[itemIndex].input_name;
                    this.currentLoadedMusicanItems[itemIndex] = response;

                    this._setRadioInputValue(this.currentLoadedMusicanItems[itemIndex]);
                    break;
                }
            }
        } else {
            var elem = $('#' + e.target.name + "_system_message");
            elem.html("Fehler beim Speichern! " + response.Message);
            elem.css("color", "red");
        }

        //spinners.global().stop();
        this.StandbyStop();
    }

    _onSelectionItemClickError(e: any, error: any): void {
        //spinners.global().stop();
        this.StandbyStop();

        var elem = $('#' + e.target.name + "_system_message");
        //elem.html("Allgemeiner Fehler beim Speichern! Bitte Seite neu laden.");
        elem.html("Fehler beim Speichern: " + error.Message);
        elem.css("color", "red");
    }

    loadProjects(): void {

        var url = window.appRoot + "SOV/OrchestraGetProjectList";

        this.RequestManager.post(
            url,
            {
            },
            lang.hitch(this, "_onLoadProjectsResponse"),
            lang.hitch(this, "_onLoadProjectsError"),
            false // sync
        );
    }

    _onLoadProjectsResponse(response: any): void {

        this._handleResponseGeneric(response);

        var target = this.project_container;
        var select = document.createElement("select");
        $(select).attr("name", "ref_ev_project");
        $(select).attr("id", "ref_ev_project");
        on(select, "change", lang.hitch(this, this._onChangeProjectSelect, select));

        for (var i = 0; i < response.FullSize; i++) {
            var eEntity = response.EntityDataArray[i];

            let str_date_start = "?";
            let str_date_end = "?";

            try {
                var date_start = new Date(parseInt(this._GetAttributeValueFromAttributeArray(eEntity.Attributes, "date_forerun").substr(6)));
                var date_end = new Date(parseInt(this._GetAttributeValueFromAttributeArray(eEntity.Attributes, "date_trailer").substr(6)));

                str_date_start = dateFormat(date_start, "dd.mm.yyyy");
                str_date_end = dateFormat(date_end, "dd.mm.yyyy");

            } catch (ex) {
                console.warn("converting date failed!", eEntity, ex)
            }


            var option = document.createElement("option");
            $(option).attr("value", this._GetAttributeValueFromAttributeArray(eEntity.Attributes, "ID"));
            $(option).html(str_date_start + " - " + str_date_end + " " + this._GetAttributeValueFromAttributeArray(eEntity.Attributes, "ev_project_name"));
            $(select).append(option);
        }

        domConstruct.place(select, target);

        this._loadedModules.push("projects");
        this.checkLoadedModules();
    }

    _onLoadProjectsError(error: any): void {
        console.log("_onLoadProjectsError", error);
    }

    _onChangeProjectSelect(select: any, evt: any): void {
        console.debug(this.id + " _onChangeProjectSelect", select, evt);

        $("#btn_load_musicans").attr("disabled", false);

        domClass.add(this.musican_table_body, "w3-disabled");
    }


    loadFunctionalHeadGroups(): void {

        //spinners.global().spin(document.getElementById('spinner_box'));
        this.StandbyStart();

        var url = window.appRoot + "SOV/OrchestraGetFunctionHeadFunctiongroups";

        this.RequestManager.post(
            url,
            {

            },
            lang.hitch(this, "_onLoadFunctionalHeadGroupsResponse"),
            lang.hitch(this, "_onLoadFunctionalHeadGroupsError"),
            false // sync
        );
    }

    _onLoadFunctionalHeadGroupsResponse(response: any): void {

        this._handleResponseGeneric(response);

        //console.log("_onLoadFunctionalHeadGroupsResponse", response);

        this._checkboxes = [];

        var table = document.createElement('table');

        var tBody = document.createElement("tbody");
        table.appendChild(tBody);

        for (var i = 0; i < response.FullSize; i++) {
            var eEntity = response.EntityDataArray[i];

            var row = tBody.insertRow(-1);
            var col = row.insertCell(-1);
            var input: any = document.createElement("input");
            input.type = "checkbox";
            input.id = "selection_function_" + i;
            input.name = "selection_function_" + i;
            input.value = this._GetAttributeValueFromAttributeArray(eEntity.Attributes, "ref_functional_group.ID")
            if (i == 0) {
                input.checked = "checked";
            }

            this._checkboxes.push(input);

            var label = document.createElement("label");
            label.innerHTML = this._GetAttributeValueFromAttributeArray(eEntity.Attributes, "ref_functional_group.description");
            label.htmlFor = input.id;

            col.appendChild(input);
            col.appendChild(label);
        }

        if (response.FullSize > 0) {
            //$("#btn_load_musicans").attr("disabled", false);
            this._loadedModules.push("functions");
            domConstruct.place(table, this.functions_table_body);
        } else {
            domConstruct.create("p", {
                "className": "w3-disabled",
                style: {
                    "fontStyle": "italic"
                },
                "innerHTML": "Keine Funktionsgruppen zum Einteilen verfügbar!"
            }, this.functions_table_body)
        }




        this.checkLoadedModules();

    }

    _onLoadFunctionalHeadGroupsError(error: any): void {
        //console.log("_onLoadFunctionalHeadGroupsError", error);
        this._handleResponseGeneric(error);
    }

    loadDispo(evt: any): void {
        domConstruct.empty(this.musican_table_body);
        //$("#musican_table_body").html(null);
        //$("#btn_load_musicans").attr("disabled", true); //TODO: geht nicht immer? manchmal ist der button einfahc immer disbled. deshalb jetzt mal einfach einschalten
        $("#btn_load_musicans").attr("disabled", true); // das is mir jetzt wurscht, das hat zu funktionieren!

        domClass.remove(this.musican_table_body, "w3-disabled");


        var checkboxes = this._checkboxes;//$("#functions_table_body input:checkbox");
        let select = $("#ref_ev_project")
        let projectId = select.val()

        this._dispoLoadRegistry = 0;
        this.currentLoadedMusicanItems = [];
        //console.log("loadDispo", this.currentLoadedMusicanItems);

        for (var i = 0; i < checkboxes.length; i++) {

            var cb = checkboxes[i];

            let functionGroupId = cb.value;

            if (cb.checked === true) {
                this._dispoLoadRegistry++;
                var functionalGroupName = $(cb).next('label').text();
                this.loadProjectDispoMusicans(functionalGroupName, projectId, functionGroupId);
            }
        }
    }

    loadProjectDispoMusicans(FunctionalGroupName: any, ProjectId: any, FunctionalGroupId: any): void {

        //spinners.global().spin(document.getElementById('spinner_box'));
        this.StandbyStart();

        var url = window.appRoot + "SOV/OrchestraGetProjectDispoMusicans";

        this.RequestManager.post(
            url,
            {
                "ProjectId": ProjectId,
                "FunctionalGroupId": FunctionalGroupId
            },
            lang.hitch(this, "_onLoadDispoMusicansResponse", FunctionalGroupName, FunctionalGroupId),
            lang.hitch(this, "_onLoadDispoMusicansError"),
            false // sync
        );
    }

    _onLoadDispoMusicansResponse(FunctionalGroupName: any, FunctionalGroupId: any, response: any): void {

        this._handleResponseGeneric(response, false);

        this.currentLoadedMusicanItems = $.merge(this.currentLoadedMusicanItems, response);

        //console.log("_onLoadDispoMusicansResponse", this.currentLoadedMusicanItems);

        var headline = document.createElement("h3");
        headline.innerHTML = FunctionalGroupName + " - " + $('#ref_ev_project').children(':selected').text();
        domConstruct.place(headline, this.musican_table_body);

        var table = document.createElement('table');

        var header = table.createTHead();
        var hrow = header.insertRow(-1);
        hrow.insertCell(-1).innerHTML = "Orchestermitglied";
        hrow.insertCell(-1).innerHTML = "Einteilung (Saisonplanung)";
        hrow.insertCell(-1).innerHTML = "Einteilung (Stimmführer)";

        var tBody = document.createElement("tbody");
        table.appendChild(tBody);

        for (var i = 0; i < response.length; i++) {
            var item = response[i];
            var jsonDataProject = null;

            var ref_vt_duty_type_code = item.DutyTypeCode;
            var ref_vt_duty_type_2_code = item.DutyTypeCode_2;

            var row = tBody.insertRow(-1);
            var col = row.insertCell(-1);
            col.innerHTML = item.Associate;
            var system_message = document.createElement("div");
            system_message.id = "selection_" + i + "_" + FunctionalGroupId.replace(":", "_") + "_system_message";

            col.appendChild(system_message);

            col = row.insertCell(-1);

            try {
                jsonDataProject = JSON.parse(item.projectJsonData);
            } catch (ex) {
                console.warn("error parsing projectJson", ex, item.projectJsonData);
            }



            //  Saisonplanung
            //
            var dutyValues = [{ label: "k.A", code: "null" }, { label: "X", code: "X" }, { label: "R", code: "R" }];
            var dutyValuesMusician = [{ label: "k.A", code: "null" }, { label: "X", code: "X" }];

            for (var d = 0; d < dutyValuesMusician.length; d++) {
                var value = dutyValuesMusician[d];
                var div = document.createElement("div");
                //domClass.add(div, "w3-disabled");

                var input: any = document.createElement("input");
                input.type = "radio";
                input.id = "sp_selection_" + i + value.code + "_" + FunctionalGroupId.replace(":", "_");
                input.name = "sp_selection_" + i + "_" + FunctionalGroupId.replace(":", "_");

                input.value = value.code;
                $(input).attr("disabled", true);

                if (value.code == "null") {
                    input.checked = true;
                }

                if (value.code == ref_vt_duty_type_code) {
                    input.checked = true;
                }

                var label = document.createElement("label");
                label.innerHTML = value.label;
                label.htmlFor = input.id;

                div.appendChild(input);
                div.appendChild(label);
                col.appendChild(div);

                // #22914
                if (jsonDataProject && jsonDataProject.lvlDispoFunctionhead != 2) {
                    domClass.add(div, "w3-disabled opaque");
                }

            }

            col = row.insertCell(-1);

            //  Stimmführer
            //
            var dutyValues = [{ label: "k.A", code: "null" }, { label: "X", code: "X" }, { label: "R", code: "R" }];
            for (var d = 0; d < dutyValues.length; d++) {
                var value = dutyValues[d];
                var div = document.createElement("div");

                var input: any = document.createElement("input");
                input.type = "radio";
                input.id = "selection_" + i + value.code + "_" + FunctionalGroupId.replace(":", "_");
                input.name = "selection_" + i + "_" + FunctionalGroupId.replace(":", "_");
                input.value = value.code;

                on(input, "click", lang.hitch(this, "_selectionItemClick"));

                if (value.code == "null") {
                    input.checked = true;
                }

                if (value.code == ref_vt_duty_type_2_code) {
                    input.checked = true;
                }

                var label = document.createElement("label");
                label.innerHTML = value.label;
                label.htmlFor = input.id;

                div.appendChild(input);
                div.appendChild(label);
                col.appendChild(div);

                // #22914
                if (jsonDataProject && jsonDataProject.lvlDispoFunctionhead != 2) {
                    domClass.add(div, "w3-disabled opaque");
                }


                item.input_name = input.name;
            }
        }

        //$("#musican_table_body").append(table);
        domConstruct.place(table, this.musican_table_body);

        this._dispoLoadRegistry--;
        if (this._dispoLoadRegistry == 0) {
            //spinners.global().stop();
            this.StandbyStop();

            $("#btn_load_musicans").attr("disabled", false);
        }

    }

    _onLoadDispoMusicansError(error: any): void {
        this._handleResponseGeneric(error);

        $("#btn_load_musicans").attr("disabled", false);
    }
}
FunctionHeadDispoMain.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.FunctionHeadDispoMain';

export default mdsWidget(FunctionHeadDispoMain);
